import React, { useEffect } from 'react';
import * as actions from '../../store/actions';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    makeStyles,
} from '@material-ui/core';
import KapinuaDialogTitle from '../KapinuaDialog/KapinuaDialogTitle';
import SnackBarType from '../../objects/app/snackbar';
import { useDispatch } from 'react-redux';
import { Size } from '../../schemas/product';
import TeamList from './TeamList';
import { useTranslation } from 'react-i18next';
import * as ValidateModel from '../../shared/ValidateModel';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export interface IMember {
    name: string;
    number: string;
    size: Size | null;
    id: number | undefined;
}

export interface ISavedTeamMember {
    name: string;
    number: string;
    size: string;
}

const useStyles = makeStyles((theme) => ({
    dialog: {
        padding: '20px',
        textAlign: 'center',
    },
    button: {
        marginTop: '20px',
    },
    dialogActions: {
        padding: '17px 37px',
    },
    bottomButton: {
        lineHeight: '24px',
        size: '20px',
        fontWeight: 400,
    },
}));

declare global {
    interface Window {
        GET_DESIGN_NAME_FCE_NAME: string;
        SET_DESIGN_NAME_FCE_NAME: string;
        GET_ID_DESIGN_FCE_NAME: string;
        SET_TEAM_FCE_NAME: string;
    }
}

const TeamDialog: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const classes = useStyles();
    const { isOpen, onClose } = props;

    useEffect(() => {
        try {
            ValidateModel.isWindowFce(
                'SET_TEAM_FCE_NAME',
                window.SET_TEAM_FCE_NAME
            );
        } catch (error: any) {
            dispatch(
                actions.addSnackbar(
                    t('Team dialog is not properly defined.') + error.message,
                    SnackBarType.WARNING,
                    false
                )
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Dialog open={isOpen} maxWidth={'md'} onClose={onClose}>
            <KapinuaDialogTitle handleOnClose={onClose} closeIcon={true}>
                <span>{t('Edit your Team Names and Sizes')}</span>
            </KapinuaDialogTitle>
            <DialogContent className={classes.dialog}>
                <TeamList />
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Grid container direction="row-reverse" spacing={2}>
                    <Grid item>
                        <Button
                            variant="contained"
                            className={classes.bottomButton}
                            onClick={() => onClose()}
                        >
                            {t('Save')}
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="outlined"
                            color="secondary"
                            className={classes.bottomButton}
                            onClick={() => onClose()}
                        >
                            {t('Edit Placement')}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
};

export default TeamDialog;
